module.exports = __webpack_public_path__ + "static/5.441ad243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling/5.png
// module id = 885
// module chunks = 230667518368419 245178253630338